import React from 'react'
import './Navbar.css'
import { Link } from 'react-scroll';
import { useState } from 'react';

const Navbar = () => {

    const [isActive, setIsActive] = useState(false);

    const shownav = () => {

        if (isActive) {
            setIsActive(false);
        }
        else {
            setIsActive(true);
        }
    }
    return (
        <>
            <div id="nav">

                <span className='Main-text' > Harish. Carpenter </span>
                <ul className='InitialList'>
                    <li className='litem'><Link to="home" spy={true} smooth={true} offset={-100} duration={2000} className='Link' >Home</Link></li>
                    <li className='litem'><Link to="about" spy={true} smooth={true} offset={-100} duration={2000} className='Link' >About</Link></li>
                    <li className='litem'><Link to="skills" spy={true} smooth={true} offset={-100} duration={2000} className='Link' >Skills</Link></li>
                    <li className='litem'><Link to="projects" spy={true} smooth={true} offset={-100} duration={2000} className='Link' >Projects</Link></li>
                    <li className='litem'><Link to="footer" spy={true} smooth={true} offset={-150} duration={2000} className='Link' >Contact</Link></li>
                </ul>
                <i class="fa-solid fa-bars" onClick={shownav}></i>
                <div className='topNavSidebar' style={{ display: isActive ? 'block' : 'none', height : isActive ? 'max-content' : '0px' }}>

                    <ul className='ListItemsNavSide'>
                        <li className='newli'><Link to="home" spy={true} smooth={true} offset={-100} duration={2000} className='Link2' >Home</Link></li>
                        <li className='newli'><Link to="about" spy={true} smooth={true} offset={-100} duration={2000} className='Link2' >About</Link></li>
                        <li className='newli'><Link to="skills" spy={true} smooth={true} offset={-100} duration={2000} className='Link2' >Skills</Link></li>
                        <li className='newli'><Link to="projects" spy={true} smooth={true} offset={-100} duration={2000} className='Link2' >Projects</Link></li>
                        <li className='newli'><Link to="footer" spy={true} smooth={true} offset={-150} duration={2000} className='Link2' >Contact</Link></li>
                    </ul>

                </div>


            </div>
        </>
    )
}

export default Navbar